import { Link } from "react-router-dom";
import { BrandLogo } from "@/components/LogoMark";
import { COMPANY, PLATFORM_LINKS, LEGAL_LINKS, REGULATORY_NOTICE, FOOTER_DISCLAIMER } from "@/lib/site";

export default function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/[0.08] bg-[#07080C]">
      {/* Regulatory status notice */}
      <div className="border-b border-white/[0.06] bg-white/[0.015]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5">
          <p data-testid="regulatory-status-notice" className="text-[12px] leading-relaxed text-zinc-400">
            <span className="label-xs text-ai-accent mr-2">Regulatory Status</span>
            {REGULATORY_NOTICE.replace("Regulatory Status: ", "")}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 grid gap-10 md:grid-cols-12">
        <div className="md:col-span-4">
          <BrandLogo className="h-6" />
          <p className="mt-5 text-sm text-zinc-300 leading-relaxed max-w-xs">
            {COMPANY.disclosure}
          </p>
          <p className="mt-3 text-xs text-zinc-500 leading-relaxed max-w-xs">
            AI-powered market intelligence, quantitative research infrastructure and analytics technology.
          </p>
          <div className="mt-6 flex gap-4 text-sm">
            <a href={COMPANY.linkedin} target="_blank" rel="noopener noreferrer" data-testid="social-linkedin" className="text-zinc-500 hover:text-white">LinkedIn</a>
            <a href={COMPANY.x} target="_blank" rel="noopener noreferrer" data-testid="social-twitter" className="text-zinc-500 hover:text-white">X</a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="label-xs mb-4">Platform</div>
          <div className="grid gap-2.5 text-sm">
            {PLATFORM_LINKS.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`footer-${l.to.slice(1)}`} className="text-zinc-400 hover:text-white transition-colors">{l.label}</Link>
            ))}
            <Link to="/insights" data-testid="footer-insights" className="text-zinc-400 hover:text-white transition-colors">Insights</Link>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="label-xs mb-4">Company</div>
          <div className="grid gap-2.5 text-sm">
            <Link to="/about" data-testid="footer-about" className="text-zinc-400 hover:text-white transition-colors">About</Link>
            <Link to="/pricing" data-testid="footer-pricing" className="text-zinc-400 hover:text-white transition-colors">Platform Access</Link>
            <Link to="/careers" data-testid="footer-careers" className="text-zinc-400 hover:text-white transition-colors">Careers</Link>
            <Link to="/contact" data-testid="footer-contact" className="text-zinc-400 hover:text-white transition-colors">Contact</Link>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="label-xs mb-4">Legal</div>
          <div className="grid gap-2.5 text-sm">
            {LEGAL_LINKS.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`footer-${l.to.slice(1)}`} className="text-zinc-400 hover:text-white transition-colors">{l.label}</Link>
            ))}
          </div>
          <div className="label-xs mt-7 mb-3">Contact</div>
          <a href={`mailto:${COMPANY.email}`} className="text-sm text-zinc-400 hover:text-white">{COMPANY.email}</a>
          <p className="mt-3 text-xs text-zinc-500 leading-relaxed">{COMPANY.address}</p>
        </div>
      </div>

      <div className="border-t border-white/[0.06]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-7 space-y-4">
          <p data-testid="footer-disclaimer" className="text-[11px] leading-relaxed text-zinc-500 max-w-5xl">
            <span className="text-zinc-400">Disclaimer:</span> {FOOTER_DISCLAIMER}
          </p>
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 text-[11px] text-zinc-600">
            <div>© {new Date().getFullYear()} {COMPANY.legalName}. All rights reserved.</div>
            <div>{COMPANY.brand} — a brand of {COMPANY.legalName}</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
